/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadAccessDetails(partiesList) {
  return await api
    .post(`/masters/getaccess`, partiesList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadMenuDetails(transactionsList) {
  return await api
    .post(`/masters/getmenu`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDashboardTransactionDetails(transactionsList) {
  return await api
    .post(`/org/getorganizationdashboard`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadUserRoleDetails(transactionsList) {
  return await api
    .post(`/masters/getrole`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadUserPermissionDetails(transactionsList) {
  return await api
    .post(`/masters/getuserpermission`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadInfoListDetails(transactionsList) {
  return await api
    .post(`/masters/getmenu`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadUserAccessListDetails(transactionsList) {
  return await api
    .post(`/masters/getuseraccess`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}




export async function loadMenuAccessListDetails(transactionsList) {
  return await api
    .post(`/masters/getmenuaccess`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadAccessDetails,
  loadRecordsMetaData,
  loadDashboardTransactionDetails,
  loadMenuDetails,
  loadUserRoleDetails,
  loadUserPermissionDetails,
  loadInfoListDetails,
  loadUserAccessListDetails,
  loadMenuAccessListDetails
};

export default remotes;
